module.exports = __webpack_public_path__ + "static/media/tucker-large-checkoutnotice.4877e1a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Tucker/tucker-large-checkoutnotice.jpg
// module id = 711
// module chunks = 0